import { lighten, Text, TextProps } from '@mantine/core'
import styles from './Text.module.css'

export const WavyText = ({
  text,
  duration = 5,
  distance = 5,
  ...props
}: Omit<TextProps, 'children'> & {
  text: string | number
  duration?: number
  distance?: number
}) => {
  return (
    <Text
      className={styles.wavyText}
      {...props}
      style={{
        '--duration': `${duration}s`,
        '--distance': `${distance}px`,
        ...props.style,
      }}
    >
      {String(text)
        .split('')
        .map((char, index) => (
          <span
            key={index}
            data-is-space={char === ' '}
            style={
              {
                '--index': index,
              } as any
            }
          >
            {char}
          </span>
        ))}
    </Text>
  )
}

export const GradientText = ({
  color,
  lightColor,
  children,
  duration = 5,
  animate = true,
  direction = '90deg',
  ...props
}: {
  color: string
  lightColor?: string
  duration?: number
  animate?: boolean
  direction?: string
  children: React.ReactNode
} & Omit<TextProps, 'children' | 'c'>) => (
  <Text
    className={styles.gradientText}
    data-animate-gradient={animate}
    {...props}
    style={{
      '--dark-color': color,
      '--light-color': lightColor ?? lighten(color, 0.5),
      '--direction': direction,
      '--animation-duration': `${duration}s`,
      ...props.style,
    }}
  >
    {children}
  </Text>
)
